import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import AppCard from 'src/components/AppCard'
import AppFirstDetails from 'src/components/details/purchase-details/AppFirstDetails'
import AppSecondDetails from 'src/components/details/purchase-details/AppSecondDetails'

// helpers
import Axios from 'src/helpers/axios'

const PurchaseDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params

  const [purchaseDetails, setPurchaseDetails] = useState('')

  useEffect(() => {
    fetchPurchaseDetails()
  }, [id]);

  const fetchPurchaseDetails = () => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/transactions/id/${id}`,
    })
      .then(({ data }) => {
        setPurchaseDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <AppCard
      className='mb-4'
      headerTitle={<h4>Purchase Details</h4>}
      bodyContent={
        <AppFirstDetails
          purchaseDetails={purchaseDetails}
        />
      }
      lowerBodyContent={
        <AppSecondDetails
          purchaseDetails={purchaseDetails}
        />
      }
    />
  )
}

export default PurchaseDetails
